import classNames from "classnames";
import React from "react";
import { Link } from "react-router-dom";
import {
  GOVGR_ACCORDION__SECTION_CONTENT,
  GOVGR_LINK__NO_UNDERLINE,
  GOVGR_LIST,
} from "../../conf/styles/GovGrAccordion";

const AccordionAreaChildren = ({ childrentable, locationname }) => {
  return (
    <>
      {childrentable.map((childrenitems, indexchildren) => {
        const lastpathlocation = locationname.split("/").pop();
        const childrenpathlocation = childrenitems.path.split("/").pop();

        let wrapperClassName = classNames(GOVGR_ACCORDION__SECTION_CONTENT, {
          "bg-[#ebebeb]": lastpathlocation === childrenpathlocation,
        });
        return (
          <div className={wrapperClassName} key={indexchildren}>
            <ul className={`${GOVGR_LIST}`}>
              <li>
                <Link to={childrenitems.path}>
                  <span className={`${GOVGR_LINK__NO_UNDERLINE}`}>
                    {childrenitems.name}
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        );
      })}
    </>
  );
};

export default AccordionAreaChildren;
